import { useMemo, useState, useEffect } from 'react';

import { isSpecialPath } from '@app/utils/route_path';

import { addLanguagePrefix } from '../utils/language-url';
import i18n from '../config';

/**
 * Хук для получения локализованного пути без навигации
 *
 * @example
 * const localizedPath = useLocalizedPath('/features/');
 * // → /ru/features/ (если текущий язык ru)
 */
export const useLocalizedPath = (path: string, skipLocalization = false): string => {
  // Отслеживаем изменения языка для реактивности
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setCurrentLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return useMemo(() => {
    // Если skipLocalization = true, возвращаем оригинальный путь
    if (skipLocalization) {
      return path;
    }

    // Проверяем, является ли ссылка внешней
    const isExternalLink =
      path.startsWith('http://') ||
      path.startsWith('https://') ||
      path.startsWith('mailto:') ||
      path.startsWith('tel:');

    // Если внешняя ссылка или специальный путь, не добавляем префикс
    if (isExternalLink || isSpecialPath(path)) {
      return path;
    }

    // Добавляем языковой префикс
    return addLanguagePrefix(path, currentLanguage);
  }, [path, skipLocalization, currentLanguage]);
};
